export default __webpack_public_path__ + "images/BE.e67aa02.png";